import React, { useEffect, useState } from "react";
import moment from "moment";
import { Modal, Button, Tabs, Checkbox, TextArea, IconDownload, InlineNotification, ConfirmationModal } from "@veneer/core";
import SpecialConditionDetailTypes3_14 from "./SpecialConditionDetailTypes3_14";
import SpecialConditionDetailTypes4 from "./SpecialConditionDetailTypes_4";
import SpecialConditionDetailTypes2_12 from "./SpecialConditionDetailTypes2_12";
import SpecialConditionAdditionalInformation from "./SpecialConditionAdditionalInformation";
import SpecialConditionDetailTypes_7 from "./SpecialConditionDetailTypes_7";
import SpecialConditionDetailTypes_1 from "./SpecialConditionDetailTypes_1";
import SpecialConditionDetailTypes_22 from "./SpecialConditionDetailTypes_22";
import SpecialConditionDetailTypes_21 from "./SpecialConditionDetailTypes_21";
import SpecialConditionDetailTypes_16 from "./SpecialConditionDetailTypes_16";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";

const connectApi = new ConnectAPI();

function SpecialConditionDetailLvlChannel({onShowModal, setShowSCDetail, onCloseSCDetailsModal, SpecialConditionDetail, aceptetLetter, rejectSCFlowby1, fileExist, setFileExist, usersList}) {
    const [t] = useTranslation();
    const [effectiveMonths, setEffectiveMonths] = useState(0)
    const [specialCondition, setSpecialCondition] = useState([])
    const [endDate, setEndDate] = useState("")
    const [loading, setLoading] = useState(false)
    let specialConditionTypeId = SpecialConditionDetail.idSpecialConditionType;

    useEffect(()=>{
        calc_initial_effectivemont();
        setSpecialCondition(SpecialConditionDetail);
    },[SpecialConditionDetail.idSpecialCondition]);

    function calc_initial_effectivemont(){
        var initial=0;
        setEndDate(SpecialConditionDetail.endDate);
        var date_start = moment(SpecialConditionDetail.startDate);
        var date_end = moment(SpecialConditionDetail.endDate);
        initial=date_end.diff(date_start, 'months');
        initial=initial+1;
        setEffectiveMonths(initial);
    }
    
    const specialConditionType = () => {
        //type 1: Maximum cost per print - type 13: Maximum CPP LS Mark
        if (specialConditionTypeId == 1 || specialConditionTypeId == 13  ) {
            return <SpecialConditionDetailTypes_1 specialCondition={SpecialConditionDetail} />
        } //type 15: Maximum Cost Per Print - XRate - type 18: Maximum CPP - Rebate
        if (specialConditionTypeId == 16 || specialConditionTypeId==18) {
            return <SpecialConditionDetailTypes_16 specialCondition={SpecialConditionDetail} />
        } //type 3: Fixed Bonus - type 14 Fixed Bonus + EPM
        if (specialConditionTypeId == 3 || specialConditionTypeId == 14) {
            return <SpecialConditionDetailTypes3_14 specialCondition={SpecialConditionDetail} />
        } //type 4: Tiers Up
        if (specialConditionTypeId == 4) {
            return <SpecialConditionDetailTypes4 specialCondition={SpecialConditionDetail} />
        } //type 2: Bonus Special Table - type 12: Bonus Special Table + EPM - type 15: Bonus Special Table - All Imp
        if (specialConditionTypeId == 2 || specialConditionTypeId == 12 || specialConditionTypeId == 15) {
            return <SpecialConditionDetailTypes2_12 specialCondition={SpecialConditionDetail}/>
        } //type 7: Combine clicks - type 17: Combine Clicks + Spl Tbl EPM - type 8: Combine Clicks + Special Table - type 19: Combine Clicks + Tiers Up
        if (specialConditionTypeId == 7 || specialConditionTypeId == 8 || specialConditionTypeId == 17 || specialConditionTypeId == 19) {
            return <SpecialConditionDetailTypes_7 specialCondition={SpecialConditionDetail} />
        } // Type 11 Minimum Discount
        if (specialConditionTypeId == 11) {
            return SpecialConditionDetail.Percentage;
        } //type 21: Run Length
        if (specialConditionTypeId == 21 ) {
            return <SpecialConditionDetailTypes_21 specialCondition={SpecialConditionDetail} />
        } //type 22: Maximum CPP - LS Discount - type 23: Low Coverage Program
        if (specialConditionTypeId == 22 || specialConditionTypeId == 23) {
            return <SpecialConditionDetailTypes_22 specialCondition={SpecialConditionDetail} />
        }
    }
    const newPress = () => {
        if (SpecialConditionDetail.newPress === true) {
            return <Checkbox
                defaultChecked
                id="newPress-checkbox-checked"
                label="New Press"
                disabled
            />
        }
    }
    const newEndUser = () => {
        if (SpecialConditionDetail.newEndUser === true) {
            return <Checkbox
                defaultChecked
                id="newEndUser-checkbox-checked"
                label="New End User"
                disabled
            />
        }
    }
    const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(0);

    const downloadPdfFile = (status, data) => {
        downloadFile( "LetterCreateiPSP\\" + SpecialConditionDetail.customerName + "\\" + data[1] );
        setFileExist(true);
        setLoading(false);
        setmultiDownload(false);
    }
    const exportData = () => {
        setLoading(true);
        let effective = "";
        if(effectiveMonths == 1)
            effective = effectiveMonths.toString() + ' Mes';
        else
            effective = effectiveMonths.toString() + ' Meses';

        let data={
            name: JSON.parse(localStorage.getItem("currentUser")).name,
            effective: effective,
            SpecialCondition:specialCondition
        }
        connectApi.post('api/Channels/createPDFtoHTML', data, downloadPdfFile);
    };

    function rejectSCFlowNote(){
        if( notesDetails == "" ){
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('addNotes')
            });
            setShowNotification(true);
        } else {
            let currentUser = JSON.parse(localStorage.getItem("currentUser"));
            if( SpecialConditionDetail.notes != "" ) 
                SpecialConditionDetail.notes += ` \n;Reject:\n${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}) Rejected because: ${notesDetails}`;
            else 
                SpecialConditionDetail.notes = ` ;Reject:\n${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}) Rejected because: ${notesDetails}`;
            setShowSCDetail(false);
            rejectSCFlowby1();
        }
    }
    function approveOrReject (){
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if(notesDetails!=""){//Se agrega ";" para delimitar el comentario de los canales.
            if(SpecialConditionDetail.notes != "")
                SpecialConditionDetail.notes += ` \n;${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}): ${notesDetails}`;
            else
                SpecialConditionDetail.notes = ` ;${currentUser.idUser}(${t('approvalLevel')}: ${SpecialConditionDetail.approvalLevel}): ${notesDetails}`;
        }
        aceptetLetter();
    }
    const [notesDetails, setNotesDetails] = useState("");
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [showNotification, setShowNotification] = useState(false);
    const [multiDownload, setmultiDownload] = useState(false);

    return ( <>
        <Modal
            id = "regular-modal"
            onClose = {() => { onCloseSCDetailsModal(); }}
            show = {onShowModal}
            css = {{
                '.vn-modal--content': {
                    width: "800px !important",
                    height:"690px !important",
                },
                }}
            title = {t('scDetails')}
        >
            <Tabs
                controlId="default"
                onChangeTab={setSelectedTabIdDefault}
                selectedTabId={selectedTabIdDefault}
                tabs={[
                    {
                        id: 0, label: t('basicInf'), content: <div style={{ padding: '15px', height:"400px", "overflow-y": "scroll", marginBottom:"20px" }}>
                            <div> {newPress()} </div>
                            <div> {newEndUser()} </div>
                            <div> Special Condition Id: {SpecialConditionDetail.idSpecialCondition} </div>
                            <div> Special condition Type: {SpecialConditionDetail.specialConditionType} </div>
                            <div> Channel: {SpecialConditionDetail.customerName} </div>
                            <div> EndUser: {SpecialConditionDetail.endUserName} </div>
                            <div> OPD #: {SpecialConditionDetail.opd} </div>
                            <div> Created By: {SpecialConditionDetail.createdBy} </div>
                            <div> Approved By: {SpecialConditionDetail.ApprovedBy} </div>
                            <div> Press: {SpecialConditionDetail.idPress} </div>
                            <div> 
                                Start date:  {t('month' + ( new Date(SpecialConditionDetail.startDate).getMonth()+1).toString()) + "/"+ new Date(SpecialConditionDetail.startDate).getFullYear()}
                            </div>
                            <div> Effective Months: {effectiveMonths} </div>
                            <div>
                                End date: {t('month' + ( new Date(endDate).getMonth()+1).toString()) + "/"+ new Date(endDate).getFullYear()}
                            </div> 
                            {specialConditionType()}
                            <div>
                                <TextArea
                                    id="text-area-uncontrolled"
                                    label="Notes"
                                    value={notesDetails}
                                    onChange={ (val) => setNotesDetails(val) }
                                    disabled={!fileExist}
                                    error={showNotification}
                                />
                            </div>
                        </div>
                    },
                    {
                        id: 1, 
                        label: t('additionalInf'), 
                        content: 
                            <div style={{ padding: '15px',  height:"400px","overflow-y": "scroll", marginBottom:"20px" }}>
                                <SpecialConditionAdditionalInformation specialCondition={SpecialConditionDetail} />
                            </div>
                    }
                ]}
            />
            {fileExist?(
                <div>
                    {showNotification ? (
                        <div className="show-animated" >
                            <InlineNotification
                                title={notificationDetails.title}
                                type={notificationDetails.type}
                                description={notificationDetails.description}
                                onClose={() => { setShowNotification(false) }}
                            /> 
                        </div>):("")
                    }
                <div>
                    <Button style={{marginRight: '5px'}} onClick={() => approveOrReject(true)}>{t('approve')}</Button>
                    <Button style={{marginRight: '5px'}} onClick={() => rejectSCFlowNote()} appearance="secondary">{t('reject')}</Button>
                    <Button onClick={() => setmultiDownload(true)} appearance="warning">{t('DownLoadLetter')}</Button>
                </div> 
                </div>
            ):(
                <div>
                    <Button 
                        leadingIcon={<IconDownload />}
                        onClick={() => {exportData();}}
                        loading={loading}
                    >{t('DownLoadLetter')}</Button>
                </div>  
            )}
        </Modal>
        <ConfirmationModal
            id="confirmation-modal" 
            onConfirm={() => exportData()}
            onClose={() => setmultiDownload(false)}
            show={multiDownload}
            title={t('userDownloadQuestion')}
        >
            <p>
                {t('userExistDownload')}<br /><br />
                {t('Emails')}:<br />
                { usersList.map( (email, index) => (
                    <span key = {index}> {index + 1}.- {email}<br /> </span>
                )) }
            </p>
      </ConfirmationModal>
    </>);
}

export default SpecialConditionDetailLvlChannel;